/* eslint-disable @typescript-eslint/no-explicit-any */
import { showError } from '../components/App/AppAlert';

const URL_BLANK = 'about:blank';
// Time after which we assume the download succeeded or timed out so we can cleanup.
const TIMEOUT_MS_DOWNLOAD = 30000;
// When we get a document from our endpoint with an error in the title.
const ERROR_TITLE_PATTERN = /^(HTTP Error: \S.*)$/;
// When we get an unexpected document load instead of file-save dialog.
const UNKNOWN_NETWORK_ERROR = 'Network Error';

function download(url: string) {
  let frame = document.createElement('iframe');
  let removeFrame: (() => void) | undefined;
  let cleanup = () => removeFrame?.();
  onNextLoad(frame, () => {
    // If we get a load event then something went wrong because a
    // save-file prompt should not load anything into the window.
    onNextLoad(frame, () => {
      clearTimeout(timeout);
      let error = checkError(frame);
      cleanup();
      error && onError(error);
    });
    frame.src = url;
    let timeout = setTimeout(cleanup, TIMEOUT_MS_DOWNLOAD);
  });
  frame.src = URL_BLANK;
  removeFrame = appendFrame(frame);
}

// TODO: See if we can remove the iframe stuff and just use the form.
function post(
  url: string,
  data: {
    [key: string]: unknown;
  },
) {
  let isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
  let frame = document.createElement('iframe');
  let removeFrame: (() => void) | undefined;
  let cleanup = () => removeFrame?.();
  onNextLoad(frame, () => {
    let document: Document = (frame.contentWindow as any).document;
    let form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    if (isIOS) {
      form.target = '_blank';
    }
    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = '__JSON__';
    input.value = JSON.stringify(data);
    form.appendChild(input);
    // If we get a load event then something went wrong because a
    // save-file prompt should not load anything into the window.
    onNextLoad(frame, () => {
      clearTimeout(timeout);
      let error = checkError(frame);
      cleanup();
      error && onError(error);
    });
    document.body && document.body.appendChild(form);
    form.submit();
    let timeout = setTimeout(cleanup, TIMEOUT_MS_DOWNLOAD);
  });
  frame.src = URL_BLANK;
  removeFrame = appendFrame(frame);
}

function onNextLoad(frame: HTMLIFrameElement, handler: (arg0: Event) => void) {
  let onLoad = (event: Event) => {
    frame.removeEventListener('load', onLoad);
    return handler(event);
  };
  frame.addEventListener('load', onLoad);
}

function onError(error: Error) {
  showError(
    t('An error occurred while fetching the download: {errorMessage}', {
      errorMessage: error.message,
    }),
  );
}

function checkError(frame: HTMLIFrameElement) {
  let window: WindowProxy = frame.contentWindow as any;
  let location: string | null | undefined;
  try {
    location = window.location.href;
  } catch (e) {}
  // Somehow we got a load event even though the location didn't change.
  if (location === URL_BLANK) {
    return;
  }
  let title: string | null | undefined;
  try {
    title = window.document.title;
  } catch (e) {}
  let match;
  if (typeof title === 'string' && (match = title.match(ERROR_TITLE_PATTERN))) {
    return new Error(match[1]);
  } else {
    return new Error(UNKNOWN_NETWORK_ERROR);
  }
}

function appendFrame(frame: HTMLIFrameElement) {
  let container = createContainer();
  document.body && document.body.appendChild(container);
  container.appendChild(frame);
  return () => {
    frame.parentNode && frame.parentNode.removeChild(frame);
    container.parentNode && container.parentNode.removeChild(container);
  };
}

function createContainer() {
  let div = document.createElement('div');
  div.className = 'download-target-container';
  div.style.display = 'none';
  return div;
}

export { onNextLoad, checkError };

let DownloadTarget = {
  download,
  post,
};

export default DownloadTarget;
